// Shared dynamic-package loader.
//
// import.meta.glob is a compile-time macro whose pattern is resolved relative to
// THIS file, so Core.jsx and index.jsx import loadPackage from here instead of
// each declaring their own (identical) glob + lookup.
//
// Vite cannot resolve fully-dynamic import() paths the way webpack's
// require.context/import() did, so package entry points are enumerated up front.
const DEBUG = import.meta.env.REACT_APP_DEBUG === "true"

const packageModules = import.meta.glob("../packages/*/index.{js,jsx}")

export const loadPackage = (name) => {
  const loader = packageModules[`../packages/${name}/index.js`] || packageModules[`../packages/${name}/index.jsx`]
  if (!loader) {
    // Package isn't bundled, or the name was derived from a route/config and has
    // no matching package. Resolve to an empty module so callers treat it as a
    // no-op (matches the old webpack import().catch behaviour) instead of
    // calling undefined() and crashing.
    if (DEBUG === true) console.warn(`Package "${name}" is not loadable; skipping.`)
    return Promise.resolve({})
  }
  return loader()
}
